import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
/**
 * 功能-清單(左邊) 
 * type= 0:資源循環推動 1:訊息中心 2:關於網站 3:資源循環教材 4:會議專區 
 * active:參考 各類別的 active 屬性
 * */
function Menu_Function_List(props) {
    const refContainer = useRef(null);
    const [type] = useState(props.type);
    const [active] = useState(props.active);

    useEffect(() => {

        var elems = refContainer.current.children;
        for (let item of elems) {
            var _active = item.getAttribute('active');
            var className = item.getAttribute('class');
            if (_active !== null && _active === active) {
                item.setAttribute('class', className + ' active');
            }
        }
    });

    /**
     * 產生畫面
     * */
    const create_view = function () {


        var data = [];
        var active = "active";

        switch (type) {

            case '0':
                data.push(
                    <ul className="menuList" ref={refContainer}>
                        <li className="menuItem t334 fb cp level">資源循環推動</li>
                        <li className="menuItem t334 fb cp" active="0"><Link title="資源循環推動說明" role="button" to="/resourceRecyclingPromotion">資源循環推動說明</Link></li>
                        <li className="menuItem t334 fb cp" active="1"><Link title="歷年推動計畫" role="button" to="/recycleReport3">歷年推動計畫</Link></li >
                        <li className="menuItem t334 fb cp" active="2"><Link title="資源回收再利用年報" role="button" to="/recycleReport">資源回收再利用年報</Link></li >
                        <li className="menuItem t334 fb cp"><a title="相關法規(另開新視窗)" rel="noopener noreferrer" target="_blank" href="https://oaout.moenv.gov.tw/law/SearchAllResultList.aspx?KW=%E8%B3%87%E6%BA%90%E5%9B%9E%E6%94%B6%E5%86%8D%E5%88%A9%E7%94%A8%E6%B3%95&type=E">相關法規</a></li>
                    </ul>);
                break;
            case '1':
                data.push(<ul className="menuList" ref={refContainer}>
                    <li className="menuItem t334 fb cp level">訊息中心</li>
                    <li className="menuItem t334 fb cp" active="0"><Link title="循環經濟新聞" to="/more/news">循環經濟新聞</Link></li>
                    <li className="menuItem t334 fb cp" active="1"><Link title="研討會" to="/more/seminar">研討會</Link></li >
                </ul>);
                break;
            case '2':
                data.push(<ul className="menuList" ref={refContainer}>
                    <li className="menuItem t334 fb cp level">關於網站</li>
                    <li className="menuItem t334 fb cp" active="0"><Link title="認識循環經濟" to="/about">認識循環經濟</Link></li>
                </ul>);
                break;
            case '3':
                data.push(<ul className="menuList" ref={refContainer}>
                    <li className="menuItem t334 fb cp level">資源循環教材</li>
                    <li className="menuItem t334 fb cp" active="0"><Link title="資源循環教材" to="/recycleReport2">資源循環教材</Link></li>
                    <li className="menuItem t334 fb cp" active="1"><Link title="相關資源" to="/recycleReport4">相關資源</Link></li>
                    <li className="menuItem t334 fb cp" active="2"><Link title="圖卡懶人包" to="/recycleReport5">圖卡懶人包</Link></li>
                    <li className="menuItem t334 fb cp" active="3"><Link title="影片" to="/recycleReport6">影片</Link></li>
                   
                </ul>);
                break;
            case '4':
                data.push(<ul className="menuList" ref={refContainer}>
                    <li className="menuItem t334 fb" active="0">會議專區</li>
                </ul>);
                break;

        }



        return (data);
    }

    return (create_view());
}

export default Menu_Function_List;